import { getEnvConfig } from 'utils/getEnvConfig'
import {
  apiRequestInterceptor,
  apiResponseErrorInterceptor,
  apiResponseSuccessInterceptor,
  businessIdInterceptor
} from './apiInterceptor'
import ApiService from './ApiService'

const MERCHANT_GET_CUSTOMERS_ENDPOINT = 'v1.0/customer?deleted=false'
const MERCHANT_GET_DELETED_CUSTOMERS_ENDPOINT = 'v1.0/customer?deleted=true'
const MERCHANT_GET_SUPPLIERS_ENDPOINT = 'v1.0/sc/suppliers'
const MERCHANT_GET_DELETED_SUPPLIERS_ENDPOINT = 'v1.0/sc/suppliers?deleted=true'

const headers = {
  'content-type': 'application/json',
  accept: 'application/json, text/plain, */*'
}
const endpoint = `${getEnvConfig('WEB_BASE_URL')}/ledger`

const api = new ApiService(endpoint, headers)
const apiV2 = new ApiService(endpoint.replace('v1', 'v2'), headers)

api.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
api.requestInterceptor(businessIdInterceptor, (error: any) => console.error(error))
api.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

apiV2.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
apiV2.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

export const getCustomersList = () => {
  return api.getRequest(MERCHANT_GET_CUSTOMERS_ENDPOINT, {})
}

export const getDeletedCustomersList = () => {
  return api.getRequest(MERCHANT_GET_DELETED_CUSTOMERS_ENDPOINT, {})
}

export const getSuppliersList = () => {
  return api.getRequest(MERCHANT_GET_SUPPLIERS_ENDPOINT, {})
}

export const getDeletedSuppliersList = () => {
  return api.getRequest(MERCHANT_GET_DELETED_SUPPLIERS_ENDPOINT, {})
}

export const CustomerListAndMerchantListApi = {
  getCustomersList,
  getDeletedCustomersList,
  getSuppliersList,
  getDeletedSuppliersList
}
